import React, { FC, useCallback, useMemo } from 'react';
import { IconButton } from '@ui/buttons/icon-button'

import { Tooltip } from '@ui/tooltip/tooltip'
import { QueueMusicIcon } from '@ui/icons/material/QueueMusic'

import { Track } from '@player/types'
import { Trans } from '@ui/i18n/trans'

import { usePlayerActions } from '@common/player/hooks/use-player-actions'
import { tracksToMediaItems} from '@app/web-player/tracks/utils/track-to-media-item'

import { queueGroupId } from '@app/web-player/queue-group-id'

export interface AddToQueueButtonProps {
    track: Track
}

export const AddToQueueButton: FC<AddToQueueButtonProps> = ({ track }) => {
    const player = usePlayerActions()

    const tracks = useMemo(() => {
        return [track]
    }, [track])

    const loadTracks = useCallback(() => {
        return Promise.resolve(tracks)
    }, tracks)


    return (
        <>
            <Tooltip delay={0} label={<Trans message="Add to queue" />}>
                <IconButton
                    className="h-32 w-32"
                    onClick={async () => {
                        const tracks = await loadTracks()
                        player.appendToQueue(
                            tracksToMediaItems(
                                tracks,
                                Array.isArray([track]) ? undefined : queueGroupId(track),
                            ),
                        )
                    }}
                >
                    <QueueMusicIcon className="h-24 w-24" />
                </IconButton>
            </Tooltip>
        </>
    )
}
